import { createTheme } from "@mui/material/styles";
import "@fontsource/inter";
import "@fontsource/inter/200.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";

import "@fontsource/jetbrains-mono/200.css";
import "@fontsource/jetbrains-mono/300.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/600.css";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "rgb(104, 168, 154)",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b3b3b3",
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    body1: {
      color: "#ffffff",
    },

    body2: {
      color: "#888",
      textTransform: "uppercase",
    },
    // headline
    h1: {
      fontSize: "3rem",
      fontFamily: "'JetBrains Mono', 'Inter', Arial, sans-serif",
      fontWeight: 100,
      color: "#ffffff",
      lineHeight: ".9em",
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
      color: "#ffffff",
    },
    h3: {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: "#ffffff",
    },
    h4: {
      fontSize: "1.25rem",
      fontWeight: 400,
      color: "#ffffff",
    },
    h5: {
      fontSize: "1.25rem",
      textTransform: "uppercase",
      fontWeight: 400,
      color: "#ffffff",
    },
  },

  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "960px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: "white",
          boxShadow: "none",
          borderRadius: 0,
          textTransform: "none",
          fontSize: "1.25em",
          margin: "1em 0",
        },
      },
      defaultProps: {
        //color: 'primary',
        variant: "contained",
      },
    },
  },
});

export default darkTheme;
